import React from 'react'
import { getCurrentWindow } from 'utils'
import { withModal, ModalConsumerProps } from 'view/shared/modal'
import { TitleBar } from 'view/shared/TitleBar'
import { OrderUploadDialog } from 'view/shared/orderUpload/OrderUploadDialog'
import { ShellWrapper, MainWrapper } from './shellLayout'
import { canUploadPositionsSelector } from 'selectors/permissionSelectors'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'

interface ShellOpenFinProps extends ModalConsumerProps {
  title: string
  children?: any
  canUploadPositions: boolean
}

const mapStateToProps = createStructuredSelector({
  canUploadPositions: canUploadPositionsSelector
})

const mapDispatchToProps = {}

class ShellOpenFinComponent extends React.Component<ShellOpenFinProps> {
  componentDidMount() {
    this.manageDocumentDroppedSubscription(false, this.props.canUploadPositions)
  }

  render() {
    return (
      <ShellWrapper>
        <TitleBar window={getCurrentWindow()} title={this.props.title} />
        <MainWrapper>{this.props.children}</MainWrapper>
      </ShellWrapper>
    )
  }

  componentDidUpdate(prevProps: ShellOpenFinProps) {
    this.manageDocumentDroppedSubscription(prevProps.canUploadPositions, this.props.canUploadPositions)
  }

  private manageDocumentDroppedSubscription = (previousCanUploadPositions: boolean, currentCanUploadPositions: boolean) => {
    if (previousCanUploadPositions === currentCanUploadPositions) {
      return
    }

    if (currentCanUploadPositions) {
      fin.desktop.InterApplicationBus.subscribe('*', 'document-dropped', this.documentDroppedListener)
    } else {
      fin.desktop.InterApplicationBus.unsubscribe('*', 'document-dropped', this.documentDroppedListener)
    }
  }

  private documentDroppedListener = (msg: any) => {
    const fileData = Uint8Array.from(Object.values(msg.fileBits))
    const file = new File([fileData], msg.fileName, {
      type: 'application/octet-stream'
    })
    this.props.showModal(<OrderUploadDialog initialFile={file} />)
  }
}

export const ShellOpenFin = withModal(connect(mapStateToProps, mapDispatchToProps)(ShellOpenFinComponent))
